<template>
    <div class="col-12 col-md-6 col-lg-4">
        <b-card
            class="skills-card apprentice-simple-card-with-banner"
            no-body>
            <b-card-img
                class="skills-card-banner banner"
                :src="routes.baseUrl() + '/images/databank_banner_default.jpg'"
                top></b-card-img>
            <b-card-body body-class="skills-card-body body">
                <div class="muted-text">
                    <p>
                        {{
                            $t(
                                'britannica.as_part_of_a_pilot_you_will_have_access_to_the_britannica_encyclopedia_through_your_school',
                            )
                        }}
                        <br />{{
                            $t(
                                'britannica.this_pilot_will_run_until_september_2021_and_we_are_curious_what_you_think_of_it',
                            )
                        }}
                        <br />{{
                            $t('britannica.send_us_your_feedback_via_the_contact_form_by_pressing_the_button_next')
                        }}
                    </p>
                </div>
            </b-card-body>
            <b-card-footer>
                <b-button
                    variant="primary"
                    :href="this.routes.baseUrl() + '/help'">
                    <i class="fa fa-comments"></i> &nbsp;&nbsp; {{ $t('britannica.give_feedback') }}</b-button
                >
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'design-2021-britannica-information-component',
};
</script>

<style scoped lang="scss">
.card-footer {
    background-color: transparent;
    border-top: none;
}

.card-footer {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
